/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ page: NonNullable<unknown> }} Admin_Billing_Bills_List_Page_LabelInputs */

const es_admin_billing_bills_list_page_label = /** @type {(inputs: Admin_Billing_Bills_List_Page_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Página ${i?.page}`)
};

const en_admin_billing_bills_list_page_label = /** @type {(inputs: Admin_Billing_Bills_List_Page_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Page ${i?.page}`)
};

/**
* | output |
* | --- |
* | "Page {page}" |
*
* @param {Admin_Billing_Bills_List_Page_LabelInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_billing_bills_list_page_label = /** @type {((inputs: Admin_Billing_Bills_List_Page_LabelInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Bills_List_Page_LabelInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_billing_bills_list_page_label(inputs)
	return en_admin_billing_bills_list_page_label(inputs)
});
export { admin_billing_bills_list_page_label as "admin.billing.bills_list.page_label" }